import { el } from './ElementBuilder.js';
import { render, renderMany } from './render.js';
import {
  button,
  input,
  icon,
  span,
  div,
  select,
  textarea,
  label
} from './presets.js';
import { registry } from './registry.js';
import { withHandlers, collectCallbacks } from './withHandlers.js';
import { bindActions, mount } from './dom.js';
import {
  normalizeIcon,
  VOID_TAGS,
  FORBIDDEN_TAGS,
  DEFAULT_BUTTON_CLASS
} from './Constants.js';

const ElementBuilder = {
  el,
  render,
  renderMany,
  button,
  input,
  icon,
  span,
  div,
  select,
  textarea,
  label,
  withHandlers,
  collectCallbacks,
  bindActions,
  mount,
  registry,
  normalizeIcon,
  VOID_TAGS,
  FORBIDDEN_TAGS,
  DEFAULT_BUTTON_CLASS
};

if (typeof window !== 'undefined') {
  window.ElementBuilder = ElementBuilder;
}

export {
  el,
  render,
  renderMany,
  button,
  input,
  icon,
  span,
  div,
  select,
  textarea,
  label,
  withHandlers,
  collectCallbacks,
  bindActions,
  mount,
  registry,
  normalizeIcon,
  VOID_TAGS,
  FORBIDDEN_TAGS,
  DEFAULT_BUTTON_CLASS
};

export default ElementBuilder;
